import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Radio,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    message,
    Tabs,
    Calendar,
    Badge
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {
    AimOutlined,
    AlertOutlined,
    ApartmentOutlined,
    AppstoreAddOutlined,
    AppstoreOutlined,
    PlusSquareOutlined,
    PlusOutlined,
    PullRequestOutlined,
    BarChartOutlined,
    ProjectOutlined,
    BuildOutlined,
    BankOutlined,
    UserSwitchOutlined,
    FileDoneOutlined,
    DatabaseOutlined,
    ContainerOutlined
} from '@ant-design/icons'
import {Line, Column} from '@ant-design/charts';
import Dqht from './dqht'
import Fycj from './fycj'
import Fytj from './fytj'
import moment from 'moment';

const {Option, OptGroup} = Select;
export default class shouye extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {},
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {
        this.props.NAV_CHANGE2('/')
        this.props.NAV_CHANGE('/', ['首页'])
        this.getdata()
    }

    getdata() {
        let that = this
        let arr = {}
        arr.yuanqu = store.getState().data.yuanqu ? store.getState().data.yuanqu : null
        fetch('/Shouye/index', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    condition: data.datalist
                })
            })
    }

    render() {
        const config = {
            style: {
                width: '100%'
            },
            animation: false,
            data: this.state.condition.chart ? this.state.condition.chart : [],
            xField: 'time',
            yField: 'value',
            seriesField: 'type',
            // xAxis: {
            //     type: 'time',
            // },
            legend: {
                layout: 'horizontal',
                position: 'bottom'
            },
        };
        return (<>
            <div className={'tongji'}>
                <div className={'box1'}>
                    <div className={'item i1'}>
                        <div className={'p1'}>
                            <BuildOutlined className={'pic'}/>
                        </div>
                        <div className={'p2'}>
                            <div className={'a1'}>入驻企业</div>
                            <div className={'a2'}>{this.state.condition.num1 ? this.state.condition.num1 : '-'}</div>
                        </div>
                    </div>
                    <div className={'item i2'}>
                        <div className={'p1'}>
                            <FileDoneOutlined className={'pic'}/>
                        </div>
                        <div className={'p2'}>
                            <div className={'a1'}>有效合同</div>
                            <div className={'a2'}>{this.state.condition.num2 ? this.state.condition.num2 : '-'}</div>
                        </div>
                    </div>
                    <div className={'item i3'}>
                        <div className={'p1'}>
                            <ApartmentOutlined className={'pic'}/>
                        </div>
                        <div className={'p2'}>
                            <div className={'a1'}>房间数</div>
                            <div className={'a2'}>{this.state.condition.num3 ? this.state.condition.num3 : '-'}</div>
                        </div>
                    </div>
                    <div className={'item i4'}>
                        <div className={'p1'}>
                            <DatabaseOutlined className={'pic'}/>
                        </div>
                        <div className={'p2'}>
                            <div className={'a1'}>已租房间</div>
                            <div className={'a2'}>{this.state.condition.num4 ? this.state.condition.num4 : '-'}</div>
                        </div>
                    </div>
                    <div className={'item i5'}>
                        <div className={'p1'}>
                            <ContainerOutlined className={'pic'}/>
                        </div>
                        <div className={'p2'}>
                            <div className={'a1'}>待租房间</div>
                            <div className={'a2'}>{this.state.condition.num5 ? this.state.condition.num5 : '-'}</div>
                        </div>
                    </div>
                </div>
                <div className={'box box2'}>
                    <div className={'title'}>
                        <div className={'p1'}>园区总览</div>
                        <div className={'p2'}></div>
                    </div>
                    <table className={'yqzl'} border={1}>
                        <tr className={'head'}>
                            <td>园区名称</td>
                            <td>有效合同</td>
                            <td>房间数</td>
                            <td>已租房间</td>
                            <td>待租房间</td>
                            <td>总租赁面积</td>
                            <td>已租面积</td>
                            <td>待租面积</td>
                            <td>使用率</td>
                            {/*<td>欠费总额</td>*/}
                        </tr>
                        {this.state.condition.yuanqu && this.state.condition.yuanqu.length ? <>
                            {this.state.condition.yuanqu.map((item, index) =>
                                <tr key={item.id}>
                                    <td>{item.name}</td>
                                    <td>{item.num9}</td>
                                    <td>{item.num1}</td>
                                    <td>{item.num2}</td>
                                    <td>{item.num3}</td>
                                    <td>{item.num4}</td>
                                    <td>{item.num5}</td>
                                    <td>{item.num6}</td>
                                    <td>{item.num7}</td>
                                    {/*<td>{item.num8}</td>*/}
                                </tr>
                            )}
                        </> : null}
                    </table>
                </div>
                {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('1') ? <>
                    <Dqht/>
                    <div className={'box box5'}>
                        <div className={'title'}>
                            <div className={'p1'}>合同统计</div>
                            <div className={'p2'}></div>
                        </div>
                        <Line {...config} />
                    </div>
                </> : null) : null}
                {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('301') ? <>
                    <Fycj/>
                    <Fytj/>
                </> : null) : null}
            </div>
        </>)
    }
}
